import { render, staticRenderFns } from "./HomepageHeader.vue?vue&type=template&id=4f05f7a6&scoped=true&"
import script from "./HomepageHeader.vue?vue&type=script&lang=js&"
export * from "./HomepageHeader.vue?vue&type=script&lang=js&"
import style0 from "./HomepageHeader.vue?vue&type=style&index=0&id=4f05f7a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f05f7a6",
  null
  
)

export default component.exports